// extracted by mini-css-extract-plugin
export default {"Breadcrumb":"Breadcrumb-styles__Breadcrumb__TOv_I","Breadcrumb__expanded":"Breadcrumb-styles__Breadcrumb__expanded__hODY8"};